import React from "react"

import { Control } from "react-hook-form"

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface RoadSafetySectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const roadSafetyOptions = [
  { value: "Up to Standard", label: "Up to Standard" },
  { value: "Satisfactory", label: "Satisfactory" },
  { value: "Needs Improvement", label: "Needs Improvement" },
  { value: "Failed Protocol", label: "Failed Protocol" },
]

const RoadSafetySection: React.FC<RoadSafetySectionProps> = ({ control, calculateResult }) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Road Safety" />

      <div className="grid grid-cols-2 gap-4">
        <RatingSelect
          control={control}
          name="roadSafetyScores.drivingBehaviour"
          label="Driving Behaviour"
          options={roadSafetyOptions}
          calculateResult={calculateResult}
        />
        <RatingSelect
          control={control}
          name="roadSafetyScores.vehicleHandling"
          label="Vehicle Handling"
          options={roadSafetyOptions}
          calculateResult={calculateResult}
        />
      </div>

      <FormField
        control={control}
        name="safetyScore"
        render={({ field }) => (
          <FormItem>
            <FormLabel>🛡️ Safety Score (0–100)</FormLabel>
            <FormControl>
              <Input
                inputMode="numeric"
                placeholder="Enter safety score"
                {...field}
                value={field.value ?? ""}
                onChange={(e) => {
                  // Strip anything that isn't a digit — safety_score is a
                  // numeric (bigint) column, so values like "95%" are invalid.
                  // Store a number (or undefined when blank) to match the schema.
                  const digitsOnly = e.target.value.replace(/\D/g, "")
                  field.onChange(digitsOnly === "" ? undefined : Number(digitsOnly))
                  calculateResult()
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}

export default RoadSafetySection
